// extracted by mini-css-extract-plugin
module.exports = {"Menu":"AddressSearchBar_Menu__2i5Lm"};